import { EnvironmentUrls } from 'Roblox';
import { urlService } from 'core-utilities';

const { economyApi, websiteUrl } = EnvironmentUrls; // websiteUrl

const cashoutUrl = 'developer-exchange/cashout';
const myMoneyUrl = '/transactions';
const membershipUrl = '/premium/membership';
export const devexHelpPageUrl = `https://en.help.roblox.com/hc/en-us/articles/203314100`;

export const ImbursementStatusType = {
  Pending: 'Pending',
  Completed: 'Completed',
  Rejected: 'Rejected'
};

export const getDevexInfoUrlConfig = () => ({
  retryable: true,
  withCredentials: true,
  url: `${economyApi}/v1/developer-exchange/info`
});

export const getCashoutUrl = () => {
  return urlService.resolveUrl(websiteUrl, cashoutUrl);
};
export const getMyMoneyUrl = () => {
  return urlService.resolveUrl(websiteUrl, myMoneyUrl);
};

export const getMembershipUrl = () => {
  return urlService.resolveUrl(websiteUrl, membershipUrl);
};
